<template>
  <RemissionsTable />
</template>

<script>
import RemissionsTable from '@/views/admin/remissions/Table.vue';

export default {
  name: 'OperadorSales',
  components: { RemissionsTable },
};
</script>
